/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import axios from "axios";
import React, { useState, useEffect } from "react";
import FunctionalityButton from "./FunctionalityButton";
import { getToken } from "@/helpers/accessTokenHelper";
import { getSiteIdentifier } from "@/helpers/siteIdentifierHelper";
import { getDocumentLink, getDriveItemId, getIsCompared } from "@/helpers/fallback-response-helper";
import { launchDocument } from "../utility/launchDocument";
import { saveDocumentAndWait } from "@/taskpane/utility/saveDocumentAndWait";
import { ensureDocumentSaved } from "@/taskpane/utility/ensureDocumentSaved";

export default function Save({
  refreshDocument,
  setRefreshDocument,
  setLoading,
  selected,
  setSelected,
  hovered,
  setHovered,
}) {
  const CurrentDoc = JSON.parse(sessionStorage.getItem("document"));
  const [initialStream, setInitialStream] = useState("");

  useEffect(async () => {
    const token = await getToken();
    axios
      .get(
        `https://addins.api.dexterity.legal/gateway/api/v1/save/version?driveItemId=${getDriveItemId(CurrentDoc)}`,
        {
          headers: {
            Authorization: "Bearer " + token,
            "Site-Identifier": getSiteIdentifier(),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        }
      )
      .then((res) => {
        axios
          .get(
            `https://addins.api.dexterity.legal/gateway/api/v1/save/stream?driveItemId=${getDriveItemId(
              CurrentDoc
            )}&versionId=${res?.data?.data}`,
            {
              headers: {
                Authorization: "Bearer " + token,
                "Site-Identifier": getSiteIdentifier(),
                "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
              },
            }
          )
          .then((result) => {
            setInitialStream(result?.data?.data);
          });
      });
  }, []);

  const save = async () => {
    setSelected && setSelected("Save");
    const token = await getToken();
    // The dialogs act on the SharePoint copy server-side and cannot reach Word, so upload the current
    // edits before either one opens.
    if (CurrentDoc.fileType !== "sent" && !(await ensureDocumentSaved())) {
      setSelected && setSelected("");
      return;
    }
    if (getIsCompared(CurrentDoc)) {
      const messageToShareDialog = JSON.stringify({
        token: token,
        data: CurrentDoc,
        compareSave: true,
      });
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/SharePDF.html`,
        {
          width: 40,
          height: 54,
          backgroundColor: "#EFECF9",
          displayInIframe: true,
        },
        (result) => {
          let dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "close") {
              dialog.close();
              setRefreshDocument(!refreshDocument);
            }
          });
        }
      );
    } else {
      var document = JSON.parse(sessionStorage.getItem("document"));
      const messageToShareDialog = JSON.stringify({
        driveItemId: getDriveItemId(document),
        folderName: document.projectName,
        fileName: document.metadata.driveItemName,
        access_token: token,
        url: getDocumentLink(document),
        projectOwner: document.user.email,
      });
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/Save.html`,
        {
          width: 50,
          height: 70,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "open") {
              launchDocument(message.data);
            }
            if (message.type === "close") {
              dialog.close();
              setSelected && setSelected("");
            }
            if (message.type === "replace") {
              Word.run(async (context) => {
                if (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent" && !(await ensureDocumentSaved())) {
                  dialog.close();
                  setSelected && setSelected("");
                  return;
                }
                axios
                  .post(
                    `https://addins.api.dexterity.legal/gateway/api/v1/save/web/${CurrentDoc?.id}/replace`,
                    {},
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Site-Identifier": getSiteIdentifier(),
                        "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
                      },
                    }
                  )
                  .then((res) => {
                    setTimeout(() => {
                      // window.location.reload();
                      setRefreshDocument(!refreshDocument);
                      dialog.close();
                      setSelected && setSelected("Share");
                    }, 3000);
                  });
              });
            }
            if (message.type === "newVersion") {
              Word.run(async (context) => {
                if (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent" && !(await ensureDocumentSaved())) {
                  dialog.close();
                  setSelected && setSelected("");
                  return;
                }

                const response = await axios.post(
                  `https://addins.api.dexterity.legal/gateway/api/v1/documents/${CurrentDoc?.id}/draft`,
                  {},
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Site-Identifier": getSiteIdentifier(),
                      "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
                    },
                  }
                );

                const documentLink = getDocumentLink(response);

                await new Promise((resolve) => {
                  setTimeout(() => {
                    setRefreshDocument(!refreshDocument);
                    resolve();
                  }, 2000);
                });

                // Revert and save the original before launching: launchDocument closes this window without
                // saving again, because a save on close strips the add-in's auto-open parts.
                if (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent") {
                  await Word.run(async (context) => {
                    const currentDocBody = context.document.body;
                    currentDocBody.insertFileFromBase64(initialStream, Word.InsertLocation.replace);
                    await context.sync();
                    const trackedChanges = currentDocBody.getTrackedChanges();
                    trackedChanges.acceptAll();
                    await context.sync();
                  });

                  await saveDocumentAndWait();
                }

                dialog.close();
                setSelected && setSelected("Share");

                if (documentLink) {
                  await launchDocument(documentLink);
                }
              });
            }
            if (message.type === "newDocument") {
              Word.run(async (context) => {
                const currentDocBody = context.document.body;
                currentDocBody.insertFileFromBase64(initialStream, Word.InsertLocation.replace);
                await context.sync();
                Word.run(async (context) => {
                  if (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent") {
                    let document = context.document;
                    document.save();
                    await context.sync();
                  }
                  dialog.close();
                  setSelected && setSelected("Share");
                });
              });
            }
          });
        }
      );
    }
  };

  return (
    <div>
      <FunctionalityButton
        id="save"
        buttonText={"Save"}
        iconName="openEnrollment"
        onClickFunction={save}
        selected={selected}
        hovered={hovered}
        setHovered={setHovered}
      />
    </div>
  );
}
